import type {
  AttributeResponse,
  PlayerResponse,
  RecStatusResponse,
  RpmPercentResponse,
} from '@on3/api';
import { CommittedStatus } from '@public/components/RecruitmentStatus/Committed/CommittedStatus';
import { PredictionStatus } from '@public/components/RecruitmentStatus/Predictions/PredictionStatus';
import { SlimTransferStatus } from '@public/components/RecruitmentStatus/SlimTransferStatus';
import clsx from 'clsx';

import styles from './StatusContainer.module.scss';

interface IStatusContainerProps {
  className?: string;
  /**Status of a players recruitment.*/
  status?: RecStatusResponse;
  /**Player Information */
  player?: PlayerResponse;
  /**A list of Player RPM Predictions*/
  rpm?: RpmPercentResponse[] | null;
  /**Changes predictions to stay horizontal for playerCard on visitList.*/
  isPlayerCard?: boolean;
  sport?: AttributeResponse;
}

export const StatusContainer = ({
  status,
  rpm,
  isPlayerCard,
  player,
  sport,
  className,
}: IStatusContainerProps) => {
  const showCommitStatus =
    status &&
    status?.type !== 'None' &&
    status?.type !== 'Decommitted' &&
    !status?.transferredAsset;
  const hasRpms = !!rpm?.length;
  const isTransfer = status?.transferredAsset?.key;
  const showPredictions = !showCommitStatus && hasRpms && !isTransfer;

  return (
    <div className={clsx(styles.block, className)} data-ui="player-status">
      {showCommitStatus && (
        <CommittedStatus player={player} sport={sport} status={status} />
      )}

      {showPredictions && (
        <PredictionStatus
          isPlayerCard={isPlayerCard}
          player={player}
          rpm={rpm}
        />
      )}
      {isTransfer && <SlimTransferStatus player={player} status={status} />}
    </div>
  );
};
